
namespace RioERP.Masters {
    export class HsnMasterColumns {
        static columnsKey = 'Masters.HsnMaster';
    }
}